module.exports = __webpack_public_path__ + "img/Beauty-1.9fbd4fa4.png";